export default __webpack_public_path__ + "8b6c7789bba545831107784e30b04afb.svg";